import styled from '../../../styles/theme';
import { TrimItemStyled } from '../TrimItemStyled';
import { rem } from 'polished';

export const TrimItemStyledAP = styled(TrimItemStyled)`
    .trimContainer {
        .buttonWrapper a {
            font-size: ${({ theme }) => theme.fontSizes.textTiny};
        }

        .header {
            .title {
                font-size: ${rem(20)};
                color: ${({ theme }) => theme.colors.primaryBlack};

                &--detail {
                    font-weight: ${({ theme }) => theme.fontWeights.textBold};
                    white-space: pre-wrap;
                }
            }
        }

        .equipmentSubtitle {
            p {
                font-size: ${({ theme }) => theme.fontSizes.textTiny};
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            }
        }

        .priceInfo {
            font-weight: ${({ theme }) => theme.fontWeights.textLight};
            display: flex;
            justify-content: center;

            &__text {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                color: ${({ theme }) => theme.colors.grey12};
                margin-top: ${rem('2px')};
                margin-bottom: ${rem('2px')};
            }

            &__clockIcon {
                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.grey12};
                    }
                }
            }
        }
        .options {
            .colorOption {
                flex: 1;
                .colorText {
                    > span {
                        color: ${({ theme }) => theme.colors.grey1};
                    }
                }

                .colorButtonWrapper {
                    margin: 0 ${rem('6px')} 0 0;
                }
            }
            .engineOption {
                flex: 1;
                margin-left: ${rem('0px')};

                .engineText {
                    color: ${({ theme }) => theme.colors.grey1};
                }

                .engineIcon {
                    margin: 0 ${rem('6px')} 0 0;
                }
            }
        }
        .benefits {
            > .heading {
                color: ${({ theme }) => theme.colors.primaryBlack};
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                line-height: ${rem(20)};
                padding-bottom: ${rem(10)};
            }
            .offer {
                justify-content: space-between;
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                color: ${({ theme }) => theme.colors.primaryBlack};
            }

            ul {
                width: 100%;
                &.bullet-points {
                    padding-left: ${rem(2)};
                    li {
                        &::before {
                            background: ${({ theme }) => theme.colors.primary};
                            border-radius: 50%;
                            width: ${rem(4)};
                            min-width: ${rem(4)};
                            height: ${rem(4)};
                            margin-right: ${rem(10)};
                        }
                    }
                }
            }
        }

        .equipmentList {
            &__info {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
            }
            &__list--item {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                font-family: ${({ theme }) => theme.fonts.fontBase};

                &::marker {
                    color: ${({ theme }) => theme.colors.primary};
                }
            }
        }

        .options {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            font-family: ${({ theme }) => theme.fonts.fontBase};
        }
    }
`;
